(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["forme-faq-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var hero = document.querySelector('[data-ff-hero]');
      var groups = Array.prototype.slice.call(document.querySelectorAll('[data-ff-group]'));
      if (!groups.length) return;

      // Category links
      var nav = hero && hero.querySelector('[data-ff-nav]');
      if (nav && !nav.children.length) {
        groups.forEach(function (g) {
          if (!g.id || !g.dataset.ffTitle) return;
          var a = document.createElement('a');
          a.href = '#' + g.id;
          a.textContent = g.dataset.ffTitle;
          nav.appendChild(a);
        });
      }

      // Search filter
      var input = hero && hero.querySelector('[data-ff-search]');
      var empty = hero && hero.querySelector('[data-ff-empty]');
      if (input) {
        input.addEventListener('input', function () {
          var term = input.value.trim().toLowerCase();
          var shown = 0;
          groups.forEach(function (g) {
            var groupShown = 0;
            g.querySelectorAll('[data-ff-item]').forEach(function (item) {
              var match = !term || item.textContent.toLowerCase().indexOf(term) !== -1;
              item.hidden = !match;
              if (term) item.open = match;
              if (match) groupShown++;
            });
            if (!term) g.querySelectorAll('[data-ff-item]').forEach(function (item) { item.open = false; });
            g.hidden = groupShown === 0;
            shown += groupShown;
          });
          if (empty) empty.hidden = shown !== 0;
        });
      }

      // Open a question linked directly, e.g. /pages/faqs#q-is-click-collect-available
      if (location.hash) {
        var target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
        if (target && target.matches('[data-ff-item]')) {
          target.open = true;
          target.scrollIntoView({ block: 'start' });
        }
      }

      // FAQPage structured data built from every question on the page
      if (!document.getElementById('ff-faq-schema')) {
        var entities = [];
        groups.forEach(function (g) {
          g.querySelectorAll('[data-ff-item]').forEach(function (item) {
            var q = item.querySelector('[data-ff-question]');
            var a = item.querySelector('[data-ff-answer]');
            if (!q || !a) return;
            entities.push({
              '@type': 'Question',
              name: q.textContent.trim(),
              acceptedAnswer: { '@type': 'Answer', text: a.innerHTML.trim() }
            });
          });
        });
        if (entities.length) {
          var s = document.createElement('script');
          s.type = 'application/ld+json';
          s.id = 'ff-faq-schema';
          s.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: entities });
          document.head.appendChild(s);
        }
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
